import type { IUnmatchedGitHubRow } from '@skystone/shared';
import { Badge } from '@/components/ui';
import { Button } from '@/components/ui/Button';

interface UnmatchedGitHubRowProps {
  row: IUnmatchedGitHubRow;
  onLink: (row: IUnmatchedGitHubRow) => void;
  onCreate: (row: IUnmatchedGitHubRow) => void;
  onMarkAsBot: (row: IUnmatchedGitHubRow) => void;
}

export function UnmatchedGitHubRow({
  row,
  onLink,
  onCreate,
  onMarkAsBot,
}: Readonly<UnmatchedGitHubRowProps>) {
  const displayName = row.name ?? row.login;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t py-3 first:border-t-0 first:pt-0">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {row.avatarUrl && (
          <img
            src={row.avatarUrl}
            alt=""
            className="h-8 w-8 flex-shrink-0 rounded-full border"
          />
        )}
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="truncate font-medium text-foreground">{displayName}</span>
            {row.type === 'Bot' && <Badge variant="warning">Bot</Badge>}
            {row.reason === 'ambiguous' && <Badge variant="warning">ambiguous</Badge>}
          </div>
          <div className="text-xs text-muted-foreground">
            <span className="mr-2">{row.email ?? '—'}</span>
            <code className="font-mono">{row.login}</code>
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Button size="sm" onClick={() => onLink(row)}>Link to Person</Button>
        <Button size="sm" variant="ghost" onClick={() => onCreate(row)}>Create new</Button>
        <Button size="sm" variant="ghost" onClick={() => onMarkAsBot(row)}>Mark as bot</Button>
      </div>
    </div>
  );
}
